@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (authorizations.length === 0 && !loading) {
  <mat-card>
    <mat-card-content>
      <div class="empty-table">
        <mat-icon>info</mat-icon>
        <p>No authorizations found</p>
      </div>
    </mat-card-content>
  </mat-card>
}

@if (authorizations.length > 0 && !loading) {
  <div class="table-container">
    <table mat-table [dataSource]="authorizations" multiTemplateDataRows class="authorization-table">
      <!-- Expand Column -->
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button aria-label="expand row" (click)="toggleRow(element); $event.stopPropagation()">
            @if (!isExpanded(element)) {
              <mat-icon>keyboard_arrow_down</mat-icon>
            }
            @if (isExpanded(element)) {
              <mat-icon>keyboard_arrow_up</mat-icon>
            }
          </button>
        </td>
      </ng-container>
      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>
      <!-- Supplier Company Column -->
      <ng-container matColumnDef="supplier_company">
        <th mat-header-cell *matHeaderCellDef>Supplier</th> <!-- @product defined label -->
        <td mat-cell *matCellDef="let element">{{ element.supplier_company }}</td>
      </ng-container>
      <!-- Created At Column -->
      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Authorization Date</th> <!-- @product defined label -->
        <td mat-cell *matCellDef="let element">{{ formatDate(element.created_at) }}</td>
      </ng-container>
      <!-- Total Amount Column -->
      <ng-container matColumnDef="total_amount">
        <th mat-header-cell *matHeaderCellDef>Total</th>
        <td mat-cell *matCellDef="let element">{{ formatCurrency(element.total_amount) }}</td>
      </ng-container>
      <!-- Captured Amount Column -->
      <ng-container matColumnDef="captured_amount">
        <th mat-header-cell *matHeaderCellDef>Captured</th>
        <td mat-cell *matCellDef="let element">{{ formatCurrency(element.captured_amount) }}</td>
      </ng-container>
      <!-- Voided Amount Column -->
      <ng-container matColumnDef="voided_amount">
        <th mat-header-cell *matHeaderCellDef>Voided</th>
        <td mat-cell *matCellDef="let element">{{ formatCurrency(element.voided_amount) }}</td>
      </ng-container>
      <!-- Remaining Amount Column -->
      <ng-container matColumnDef="remaining_amount">
        <th mat-header-cell *matHeaderCellDef>Remaining</th>
        <td mat-cell *matCellDef="let element">{{ formatCurrency(element.remainingAmount) }}</td>
      </ng-container>
      <!-- Expanded Content Column -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-cell">
          <div class="expanded-detail" [@detailExpand]="isExpanded(element) ? 'expanded' : 'collapsed'">
            @if (isExpanded(element)) {
              <div class="posted-transactions-container">
                <h3>Transaction Events</h3>
                @if (getTransactionEvents(element).length === 0) {
                  <div class="no-transactions">
                    <mat-icon>info</mat-icon>
                    <p>No transaction events found</p>
                  </div>
                }
                @if (getTransactionEvents(element).length > 0) {
                  <table mat-table [dataSource]="getTransactionEvents(element)" class="posted-transactions-table"
                    >
                    <!-- Transaction ID Column -->
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
                      <td mat-cell *matCellDef="let transaction">{{ transaction.id }}</td>
                    </ng-container>
                    <!-- Status Title Case Column -->
                    <ng-container matColumnDef="statusTitleCase">
                      <th mat-header-cell *matHeaderCellDef>Status</th>
                      <td mat-cell *matCellDef="let transaction">
                        <span class="status-badge" [class]="'status-' + transaction.status">
                          {{ transaction.statusTitleCase }}
                        </span>
                      </td>
                    </ng-container>
                    <!-- Amount Column -->
                    <ng-container matColumnDef="amount">
                      <th mat-header-cell *matHeaderCellDef>Amount</th>
                      <td mat-cell *matCellDef="let transaction">{{ formatCurrency(transaction.amount) }}</td>
                    </ng-container>
                    <!-- Memo Column -->
                    <ng-container matColumnDef="memo">
                      <th mat-header-cell *matHeaderCellDef>Memo</th>
                      <td mat-cell *matCellDef="let transaction">{{ transaction.memo }}</td>
                    </ng-container>
                    <!-- Last Updated At Column -->
                    <ng-container matColumnDef="last_updated_at">
                      <th mat-header-cell *matHeaderCellDef>Last Update Date</th>
                      <td mat-cell *matCellDef="let transaction">{{ formatDate(transaction.last_updated_at) }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="transactionEventColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: transactionEventColumns;"></tr>
                  </table>
                }
              </div>
            }
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="authorization-row" [class.expanded]="isExpanded(element)" (click)="toggleRow(element)"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-row"></tr>
    </table>
  </div>
}